export class Reservation
{
    reservationId: number;
}
